import { api } from "./apiClient";

export const userService = {
  overview: async () => (await api.get("/users/me/overview")).data,
  updateProfile: async (payload) => (await api.patch("/users/me/profile", payload)).data,
  changePassword: async (current_password, new_password) =>
    (await api.post("/users/me/password", { current_password, new_password })).data,
};
